export default {
  zh: {
    wealth: '财富',
    charm: '魅力',
    Gifts: 'Hediye gönder',
    Aristocracy: 'Aristokrasi al',
    Mounts: 'Araç al',
    upgrade: '如何升级？',
    Previleges: 'Previleges',
    coins: '1 coin=1 EXP'
  },
  ar: {
    wealth: 'ثروة',
    charm: 'كاريزما',
    Gifts: 'إرسال الهدية',
    Aristocracy: 'إشتراء الإستقراطية',
    Mounts: 'إشتراء الركوب',
    upgrade: 'كيف رفع المستوى؟',
    Previleges: 'التفضيلات',
    coins: '1 عملة = 1 خبرة'
  },
  en: {
    wealth: 'Wealth',
    charm: 'Charm',
    Gifts: 'Send Gift',
    Aristocracy: 'Buy Aristocracy',
    Mounts: 'Buy Mount',
    upgrade: 'How to upgrade?',
    Previleges: 'Previleges',
    coins: '1 coin=1 EXP'
  },
  tr: {
    wealth: 'Zenginlik',
    charm: 'Cazibe',
    Gifts: 'Hediye gönder',
    Aristocracy: 'Aristokrasi al',
    Mounts: 'Araç al',
    upgrade: 'Nasıl seviye yükseltir？',
    Previleges: 'Ayrıcalıklar',
    coins: '1 jeton=1 EXP'
  },
  pt: {
    wealth: 'Riqueza',
    charm: 'Charme',
    Gifts: 'Enviar presente',
    Aristocracy: 'Comprar Aristocracia',
    Mounts: 'Comprar Montaria',
    upgrade: 'Como fazer upgrade?',
    Previleges: 'Privilégios',
    coins: '1 moeda = 1 EXP'
  },
  id: {
    wealth: 'Kekayaan',
    charm: 'Pesona',
    Gifts: 'Kirim Hadiah',
    Aristocracy: 'Beli Aristokrasi',
    Mounts: 'Beli Kuda',
    upgrade: 'Bagaimana cara meningkatkan?',
    Previleges: 'Hak Istimewa',
    coins: '1 koin = 1 EXP'
  },
  uz: {
    wealth: 'Boylik',
    charm: 'Jozibadorlik',
    Gifts: "Sovg'a yuboring",
    Aristocracy: 'Aristokratiya sotib oling',
    Mounts: 'Yuklarni sotib oling',
    upgrade: 'Qanday qilib yangilash kerak?',
    Previleges: 'Imtiyozlar',
    coins: '1 tangacha = 1 EXP'
  },
  ru: {
    wealth: 'Богатство',
    charm: 'Очарование',
    Gifts: 'Отправить подарок',
    Aristocracy: 'Купить аристократию',
    Mounts: 'Купить маунт',
    upgrade: 'Как обновить?',
    Previleges: 'Привилегии',
    coins: '1 монета = 1 EXP'
  },
  fa: {
    wealth: 'ثروت',
    charm: 'جاذبه',
    Gifts: 'ارسال هدیه',
    Aristocracy: 'خرید اشرافیت',
    Mounts: 'خرید مرکب',
    upgrade: 'چگونه ارتقا دهیم؟',
    Previleges: 'امتیازات',
    coins: '1 سکه = 1 EXP'
  },
  ur: {
    wealth: 'دولت',
    charm: 'دلکشی',
    Gifts: 'گفٹ بھیجیں',
    Aristocracy: 'اشرافیت خریدیں',
    Mounts: 'سواری خریدیں',
    upgrade: 'کیسے ترقی کریں؟',
    Previleges: 'مراعات',
    coins: '1 سکہ = 1 EXP'
  }
}



// WEBPACK FOOTER //
// src/pages/activity/newLevel/lang.js